import React from "react";
import { RichTagsWithPopover } from "kontrolEdge/components/Shared/TagsWithPopover/RichTagsWithPopover";
import type { ResourceTagSummary } from "kontrolEdge/components/Shared/NameTagEdit/useResourceTags";

interface ResourceTagsTableCellProps {
	tagsRich?: ResourceTagSummary[] | null;
	maxVisible?: number;
	triggerSingleRow?: boolean;
}

/** Tags column cell for KE resource lists — pivot-backed tags only. */
export function ResourceTagsTableCell({
	tagsRich,
	maxVisible = 1,
	triggerSingleRow = false,
}: ResourceTagsTableCellProps) {
	if (tagsRich != null && tagsRich.length > 0) {
		return (
			<RichTagsWithPopover
				tags={tagsRich}
				maxVisible={maxVisible}
				triggerSingleRow={triggerSingleRow}
			/>
		);
	}
	return <span className="text-semantic-text-secondary">–</span>;
}
